import axios from 'axios'
// 创建一个axios的对象
const instance = axios.create({
  baseURL: 'http://www.dkjtapp.com/ICBalanceEx_2008_JN_EX/qrpay', // baseURL会在发送请求的时候拼接在url前面
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'withCredentials': true
  }
})
// 请求拦截
// 所有的网络请求都会先走这个方法,我们可以在它里面为请求添加一些自定义的内容
instance.interceptors.request.use(
  function (config) {
    // console.log('全局请求拦截', config)
    // config.headers.token = '123456'  // token
    config.headers.withCredentials = true  // token
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)

// 响应拦截
// 所有的网络请求返回数据之后都会先执行此方法
//  此处可以根据服务器的返回状态码做相应的处理
//  404  401 500等
instance.interceptors.response.use(
  function (response) {
    // console.log('全局响应拦截', response)
    return response
  },
  function (err) {
    return Promise.reject(err)
  }
)

// get请求
export function get (url, params) {
  return instance.get(url, {
    params
  })
}

/* post请求 */
export function post (url, data) {
  return instance.post(url, data)
}

/* delt请求 */
export function del (url) {
  return instance.delete(url)
}

/* put请求 */
export function put (url, data) {
  return instance.put(url, data)
}



// WEBPACK FOOTER //
// ./src/utils/request.js